import { Link } from "react-router-dom";

export const SmartLink = ({ to, children, ...rest }) => {
  if (!to) return <span {...rest}>{children}</span>;
  if (/^(https?:|mailto:|tel:)/.test(to)) {
    return <a href={to} target={to.startsWith("http") ? "_blank" : undefined} rel="noreferrer" {...rest}>{children}</a>;
  }
  return <Link to={to} {...rest}>{children}</Link>;
};
